import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const viewport = {
  content: "width=device-width, initial-scale=1.0, user-scalable=no"
}

const router = new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/home/' : '/',
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: "/index",
      name: "index",
      component: () => import("@/views/Index.vue"),
      meta: {title: '工作台', viewport: viewport}
    },
    {
      path: "/cases",
      name: "cases",
      component: () => import("@/views/cases/index.vue"),
      meta: {title: '案件', viewport: viewport}
    },
    {
      path: "/consulting",
      name: "consulting",
      component: () => import("@/views/consulting/index.vue"),
      meta: {title: '咨询', viewport: viewport}
    },
    {
      path: "/contracts",
      name: "contracts",
      component: () => import("@/views/contracts/index.vue"),
      meta: {title: '合同', viewport: viewport}
    },
    {
      path: "/workspace",
      name: "workspace",
      component: () => import("@/views/workspace/WorkSpace.vue"),
      meta: {title: '工作区', viewport: viewport}
    },
    {
      path: "/setschedule",
      name: "setschedule",
      component: () => import("@/views/cases/setschedule.vue"),
      meta: {title: '设置日程', viewport: viewport}
    },
    {
      path: "/cases/info",
      name: "caseInfo",
      component: () => import("@/views/cases/info.vue"),
      meta: {title: '案件详情', viewport: viewport}
    },
    {
      path: "/printform",
      name: "printform",
      component: () => import("@/views/cases/printform.vue"),
      meta: {title: '打印', viewport: viewport}
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index.vue'),
      meta: { title: '登录' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.content) {
    let head = document.getElementsByTagName('head')
    let meta = document.createElement('meta')
    meta.name = 'viewport'
    meta.content = "width=device-width, initial-scale=1.0, user-scalable=no"
    head[0].appendChild(meta)
  }
  const token = localStorage.getItem('token')
  const fullPath = process.env.NODE_ENV === 'production' ? '/home' + to.path : to.path
  if (to.path !== '/login' && !token) {
    next('/login')
  } else {
    next()
  }
  sessionStorage.setItem('router-path', fullPath)
})

export default router;
